import React from 'react';

const ReactRouterIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="70"
            width="70"
            preserveAspectRatio="xMidYMid"
            viewBox="0 -30 255 200"
        >
            <path
                fill="#c5021a"
                d="M190.318 91.214c-4.826 1.575-10.015 2.059-15.056 2.942-1.372.24-2.82.026-4.205.218-10.753 1.492-14.816 5.799-16.335 17.249-.808 6.095-2.412 11.888-5.91 17.074-5.91 8.759-17.391 12.734-27.217 9.312-10.518-3.663-16.89-13.25-16.04-24.135.766-9.807 8.512-18.471 19.39-20.989 5.094-1.179 10.379-1.64 15.605-2.116 9.755-.887 14.064-5.164 15.689-14.756.935-5.519.102-10.726-1.122-15.932-1.87-7.957-7.663-11.654-17.39-12.362-5.308-.387-10.708-1.157-15.787-2.683-10.692-3.215-16.917-12.497-16.424-23.386.432-9.535 8.197-18.819 17.524-20.951 11.05-2.527 22.05 1.892 26.75 11.733 2.466 5.164 3.82 11.014 4.786 16.705 1.729 10.204 5.783 14.163 15.96 15.269 6.583.716 13.29 1.532 19.567 3.496 9.532 2.983 15.258 11.866 15.256 21.738-.001 9.657-5.911 18.595-15.041 21.574z"
            ></path>
            <path
                fill="#21232f"
                d="M78.072 92.782c-12.778.002-23.21-10.427-23.212-23.203-.002-12.777 10.427-23.21 23.203-23.212 12.777-.002 23.209 10.427 23.211 23.203.002 12.777-10.427 23.21-23.202 23.212zM23.13 139.2C10.363 139.168-.032 128.703 0 115.915c.032-12.767 10.496-23.162 23.284-23.129 12.767.031 23.162 10.496 23.13 23.284-.032 12.767-10.496 23.162-23.284 23.13zm209.832 0c-12.8.073-23.309-10.28-23.382-23.033-.073-12.799 10.28-23.309 23.033-23.381 12.8-.074 23.308 10.278 23.382 23.032.073 12.799-10.28 23.309-23.033 23.382z"
            ></path>
        </svg>
    );
};

export default ReactRouterIcon;